module.exports = __webpack_public_path__ + "assets/img/8.c968b134.jpg";